var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckoutHotspots = function SvgCheckoutHotspots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 52 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.648 29.467q0 3.413 1.82 6.269a11.4 11.4 0 0 0 4.896 4.284 4.516 4.516 0 0 1-.774-2.53q0-1.166.462-2.21a6.2 6.2 0 0 1 1.295-1.878l4.187-4.126 4.225 4.126a5.9 5.9 0 0 1 1.276 1.878q.442 1.044.442 2.21a4.5 4.5 0 0 1-.774 2.53 11.4 11.4 0 0 0 4.895-4.284q1.821-2.856 1.821-6.269 0-2.475-.916-4.68a12.1 12.1 0 0 0-2.65-3.937 7.825 7.825 0 0 1-4.309 1.288q-3.108 0-5.36-2.031-2.254-2.03-2.563-5.078a27 27 0 0 0-3.417 3.354 22 22 0 0 0-2.5 3.604 17.3 17.3 0 0 0-1.536 3.728 14 14 0 0 0-.52 3.752m11.886 2.575-2.823 2.774a3.9 3.9 0 0 0-.842 1.238 3.6 3.6 0 0 0-.297 1.436q0 1.584 1.164 2.724 1.163 1.139 2.798 1.139 1.634 0 2.798-1.14t1.164-2.723q0-.792-.298-1.461a4 4 0 0 0-.841-1.213zM20.553 11.22v2.995q0 2.521 1.735 4.232 1.736 1.71 4.257 1.71.93 0 1.812-.314a6.3 6.3 0 0 0 1.666-.905l.853-.67q2.598 1.927 4.061 4.9a14.1 14.1 0 0 1 1.463 6.3q0 5.799-4.034 9.832-4.035 4.035-9.832 4.035T12.7 39.299q-4.034-4.033-4.034-9.832 0-5.094 3.198-9.962t8.688-8.286m21.79 11.315a.96.96 0 0 1-.707-.284.96.96 0 0 1-.283-.707.96.96 0 0 1 .283-.706.96.96 0 0 1 .707-.284.96.96 0 0 1 .707.284.96.96 0 0 1 .284.706.96.96 0 0 1-.284.707.96.96 0 0 1-.707.284m-.99-5.486V8.667h1.98v8.38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA4F25",
    d: "M41.477 22.344q.31.31.773.31t.773-.31a1.05 1.05 0 0 0 .31-.773q0-.462-.31-.773a1.05 1.05 0 0 0-.773-.31q-.462 0-.773.31-.31.31-.31.773 0 .462.31.773M41.167 8.667v9.167h2.167V8.667z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#checkout-hotspots_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FA4F25",
    d: "M28.573 37.817c0 3.272-2.69 5.517-6.01 5.517-3.318 0-6.008-2.245-6.008-5.517s1.215-3.873 6.009-8.6c4.662 4.596 6.009 5.328 6.009 8.6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "checkout-hotspots_svg__a",
    width: 14.019,
    height: 16.117,
    x: 15.555,
    y: 28.217,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6729_15634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6729_15634",
    result: "shape"
  })))));
};
export default SvgCheckoutHotspots;